export const social = [
    {
        name:'instagram',
        link:'https://www.instagram.com/randhawa._.manpreet?igsh=aDd2czR3OHE1bndn&utm_source=qr'
    },
    {
        name:'linkedin',
        link:'https://www.linkedin.com/in/manpreet-kaur-b9bb68280?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app'
    },
    {
        name:'github',
        link:'https://github.com/mkrandhawa'
    }
]